import React from "react";
import { useSelector } from "react-redux";
import OnboardingFlow from "../../components/onboarding/OnboardingFlow";

const OnboardingExpeditorPage = () => {
  const { user } = useSelector((state) => state);

  return <OnboardingFlow user={user} role="expeditor" />;
};

export default OnboardingExpeditorPage;
